import type { FunctionComponent, PropsWithChildren } from 'react';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { SearchLandingPageStickyHeader } from '../SearchLandingPageStickyHeader/SearchLandingPageStickyHeader';
import { SearchLandingPageHeaderTitleWithData } from '../SearchLandingPageHeaderTitle/SearchLandingPageHeaderTitleWithData';
import { SearchLandingPageBreadCrumbsWithData } from '../SearchLandingPageBreadCrumbs/SearchLandingPageBreadCrumbs';
import { WebLink } from '../../../app-kit/components/WebLink/WebLink';
import { mediaHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapBadgeVariant } from '../../../app-kit/helpers/mapBadgeVariant';
import { styled } from 'styled-components';
import { SearchLandingSortMenuSelectWithData } from '../SearchLandingSortMenuSelectWithData/SearchLandingSortMenuSelectWithData';

export const ShowMapButton = styled(WebLink)`
  ${typographyHelper('body02')};
  flex-grow: 0;
  margin-right: -${spacingHelper('medium')};
  ${mediaHelper('mobileSmall')} {
    margin-right: -${spacingHelper('small')};
  }
`;

export const SearchLandingPageHeaderWithData: FunctionComponent<PropsWithChildren> = () => {
  const data = useSearchLandingPageBySlugQuery();

  if (!data) return null;

  const mapViewButton = data?.header?.mapViewButtonV2;
  const mapSplitViewButton = data?.header?.mapSplitViewButton;

  return (
    <SearchLandingPageStickyHeader
      title={<SearchLandingPageHeaderTitleWithData />}
      sorting={<SearchLandingSortMenuSelectWithData />}
      mapViewButton={
        mapViewButton ? (
          <ShowMapButton
            {...{
              ...mapViewButton,
              variant: mapApiWeblinkVariantToLinkVariant(mapViewButton.variant),
              iconInfo: mapViewButton.iconInfo
                ? mapApiWeblinkIconInfoToLinkIconInfo(mapViewButton.iconInfo)
                : null,
              callout: mapViewButton.callout
                ? {
                    ...mapViewButton.callout,
                    variant: mapBadgeVariant(mapViewButton.callout.variant),
                  }
                : null,
              sizeVariant: 'small',
            }}
          />
        ) : null
      }
      mapSplitViewButton={
        mapSplitViewButton ? (
          <ShowMapButton
            {...{
              ...mapSplitViewButton,
              variant: mapApiWeblinkVariantToLinkVariant(mapSplitViewButton.variant),
              iconInfo: mapSplitViewButton.iconInfo
                ? mapApiWeblinkIconInfoToLinkIconInfo(mapSplitViewButton.iconInfo)
                : null,
              callout: mapSplitViewButton.callout
                ? {
                    ...mapSplitViewButton.callout,
                    variant: mapBadgeVariant(mapSplitViewButton.callout.variant),
                  }
                : null,
              sizeVariant: 'small',
            }}
          />
        ) : null
      }
      breadcrumbs={<SearchLandingPageBreadCrumbsWithData />}
    />
  );
};
